import React from "react";
import "./header.css";
import people from "../../assets/people.png"
import ai from "../../assets/ai.png"
const Header = () => {
    return (
        <div className="gpt3__header section__padding" id="Home">
            <div className="gpt3__header-content" id="here">
                <h1 className="gradient__text">
                    Let's Build Something amazing with GPT-3 OpenAI
                </h1>
                <p>Few months since the launch of the first commercial product, the OpenAI API, more than 300 applications are now using GPT-3, and tens of thousands of developers around the globe are building on the platform. It currently generate an average of 4.5 billion words per day, and continue to scale production traffic.</p>
                <div className="gpt3__header-content__input">
                    <input type="email" placeholder="Your Email Address" />
                    <button type="button">Get Started</button>
                </div> 
                <div className="gpt3__header-content__people">
                    <img src={people} alt="people" />
                    <p>1,600 people requested access a visit in last 24 hours</p>
                </div>
               
            </div>
            <div className="gpt3__header-image">
                <img src={ai} alt="ai" />
            </div>
        </div>
    );
};

export default Header;
